import Vue from 'vue'
import {
  SET_COMPANY_TYPES,
  SET_CURRENT_BRANCH,
  UPDATE_CURRENT_BRANCH_ID,
  RESET_CURRENT_BRANCH,
  SET_COMPANY_BRANCHES,
  SET_SIDEBAR_ITEMS,
  SET_CURRENT_BRANCH_EMPLOYEES,
  DELETE_CURRENT_BRANCH_EMPLOYEE,
  SET_CURRENT_BRANCH_PAYMENTS
} from '../mutations.types'
export default {
  [SET_COMPANY_TYPES](state, data) {
    Vue.set(state, 'company_types', data)
  },
  [SET_CURRENT_BRANCH_PAYMENTS](state, data) {
    const dataGroupByKey = data.results.reduce(function(r, a) {
      r[a.employee] = r[a.employee] || []
      r[a.employee].push(a)
      return r
    }, Object.create(null))
    const current_payments_order = Object.entries(dataGroupByKey).map(entry => {
      return {
        name: entry[0],
        tips: entry[1]
      }
    })

    Vue.set(state, 'current_payments', data.results)
    Vue.set(state, 'current_payments_order', current_payments_order)
    Vue.set(state, 'currentPaymentsPages', Math.ceil(data.count / 100))
    Vue.set(state, 'currentTotalAmountRubles', data.total_amount_rubles ? data.total_amount_rubles : '0')
    // Vue.set(state, 'currentSuccessAmountRubles', data.success_amount_rubles ? data.success_amount_rubles : '0')
  },
  [UPDATE_CURRENT_BRANCH_ID](state, data) {
    state.current_branch.id = data
  },
  [SET_CURRENT_BRANCH](state, data) {
    if (!data.bank_card) {
      data.bank_card = {
        card_name: null,
        card_date: null,
        card_number: null
      }
    }
    if (!data.bank_account) {
      data.bank_account = {
        account_name: null,
        bik: null,
        account_number: null
      }
    }

    Vue.set(state, 'current_branch', data)
  },
  [RESET_CURRENT_BRANCH](state) {
    state.current_branch = {
      id: null,
      address: '',
      name: '',
      payments_strategy: 'PE',
      first_name: '',
      last_name: '',
      phone_number: ''
    }
  },
  [SET_CURRENT_BRANCH_EMPLOYEES](state, data) {
    data = data.map(e => ({
      ...e,
      'card_count': 4
    }))
    state.current_branch_employees = data
  },
  [DELETE_CURRENT_BRANCH_EMPLOYEE](state, data) {
    const i = state.current_branch_employees.map(item => item.id).indexOf(data)
    state.current_branch_employees.splice(i, 1)
  },
  [SET_SIDEBAR_ITEMS](state, data) {
    var convertedBranches = []
    data.forEach(function(element) {
      convertedBranches.push({
        'url': `/branches/${element.id}`,
        'name': `${element.name}`,
        icon: 'BuildingHomeIcon',
        submenu: [{
          url: `/branches/${element.id}/profile`,
          name_i18n: 'pages.profile'
        },
        {
          url: `/branches/${element.id}/employees`,
          name_i18n: 'pages.employees'
        },
        {
          url: `/branches/${element.id}/qr`,
          name_i18n: 'pages.generalPage'
        },
        {
          url: `/tips/${element.id}`,
          name_i18n: 'pages.tipAnalytics'
        }
        ]
      })
    })
    state.current_sidebar_items = convertedBranches
  },
  [SET_COMPANY_BRANCHES](state, data) {
    state.branches = data
  }
}
